import { Combobox as HeadlessUICombobox } from "@headlessui/react-v2";
import classNames from "classnames";
import type { ComponentPropsWithoutRef } from "react";

export interface ComboboxComponentProps<T = unknown> {
  children: ComponentPropsWithoutRef<typeof HeadlessUICombobox>["children"];
  className?: string;
  onChange: (value: T | null) => void;
  value?: T | null;
}

export const ComboboxComponent = <T,>({
  children,
  value,
  onChange,
  className,
  ...rest
}: ComboboxComponentProps<T>) => (
  <div className={classNames("relative", className)}>
    <HeadlessUICombobox as="div" value={value} onChange={onChange} {...rest}>
      {children}
    </HeadlessUICombobox>
  </div>
);
